import React, { useEffect, useState } from "react";
import { Sparkles, Menu, X } from "lucide-react";

const LINKS = [
  { href: "#about", label: "About" },
  { href: "#skills", label: "Skills" },
  { href: "#ai", label: "AI Lab" },
  { href: "#projects", label: "Projects" },
  { href: "#certs", label: "Certs" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-40 transition-all duration-500 ${
        scrolled ? "py-3" : "py-6"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5">
        <div
          className={`glass flex items-center justify-between rounded-full px-4 py-2.5 sm:px-6 ${
            scrolled ? "shadow-[0_10px_40px_-20px_rgba(0,0,0,0.7)]" : ""
          }`}
        >
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-2 font-mono-ed text-sm tracking-tight"
          >
            <span className="relative inline-flex h-2 w-2 rounded-full bg-[var(--jewel)] dot-live" />
            <span className="text-foreground/90">shivmurat</span>
            <span className="text-muted-foreground">.gupta</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="font-mono-ed text-[0.78rem] uppercase tracking-widest text-muted-foreground hover:text-foreground rounded-full px-3 py-1.5 transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <a
              href="#ai"
              data-testid="nav-ai-cta"
              className="hidden sm:inline-flex items-center gap-2 btn-ink px-4 py-2 text-sm"
            >
              <Sparkles size={14} /> AI Lab
            </a>
            <button
              data-testid="nav-mobile-toggle"
              aria-label="Toggle menu"
              className="md:hidden h-9 w-9 grid place-items-center rounded-full border border-white/10"
              onClick={() => setOpen((v) => !v)}
            >
              {open ? <X size={16} /> : <Menu size={16} />}
            </button>
          </div>
        </div>

        {open && (
          <div
            data-testid="nav-mobile-menu"
            className="glass mt-2 rounded-2xl p-2 md:hidden"
          >
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block px-4 py-3 font-mono-ed text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground"
              >
                {l.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}
